import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { parseDetailUrl } from '@/utils';
import GroupPurchaseBulletScreen from "@/components/GroupPurchaseBulletScreen/index";
import Drip from 'drip';
export default {
  name: 'PricePreSaleCard',
  components: {
    GroupPurchaseBulletScreen: GroupPurchaseBulletScreen
  },
  props: {
    specialPriceList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    preSaleList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isNewSpecialPrice: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      activeTab: 1,
      // 1 ：临演特， 2：早鸟预售
      morePostUrlList: [],
      showList: [],
      // 展示的list
      list: []
    };
  },
  computed: {
    hideSpecialPriceList: function hideSpecialPriceList() {
      return this.specialPriceList.length <= 4;
    },
    hidePreSaleList: function hidePreSaleList() {
      return this.preSaleList.length <= 4;
    },
    titleImg: function titleImg() {
      return this.activeTab === 2 ? 'https://p0.pipi.cn/rock/prod/common/image/55df4931a2bb83362651005a48842d49.png?imageMogr2/thumbnail/2500x2500%3E' : 'https://p0.pipi.cn/rock/prod/common/image/072ff68afe7a59cf67fcb14b5d8b3060.png?imageMogr2/thumbnail/2500x2500%3E';
    }
  },
  watch: {
    activeTab: 'initList',
    specialPriceList: 'initList',
    preSaleList: 'initList'
  },
  mounted: function mounted() {
    this.initList();
    var scrollEl = document.getElementById('calendar-scroll-view-stats');
    scrollEl.addEventListener('scroll', window.StatusReportData, false);
    window.seedAction({
      evt: 'view',
      bid: 'b_movie_bnzf3zsc_mv',
      custom: {
        abtest: 1
      }
    });
  },
  methods: {
    initList: function initList() {
      var _this = this;
      this.$refs.calendarCon.scrollLeft = 0;
      if (this.activeTab === 1 && this.specialPriceList.length > 4) {
        this.list = this.specialPriceList;
      } else {
        this.activeTab = 2;
        this.list = this.preSaleList;
      }
      if (this.list.length > 15) {
        // 铺开展示12个，第13个卡片展示为查看全部，图片为第13-16个项目海报拼出的四宫格
        this.showList = this.list.slice(0, 12).map(function (show) {
          return _this.initPrice(show);
        });
        var postList = this.list.slice(12, 16);
        this.morePostUrlList = postList.map(function (item) {
          return item.posterUrl;
        });
      } else if (this.list.length > 12) {
        this.showList = this.list.slice(0, 12).map(function (show) {
          return _this.initPrice(show);
        });
        var _postList = this.list.slice(-4);
        this.morePostUrlList = _postList.map(function (item) {
          return item.posterUrl;
        });
      } else {
        this.showList = _toConsumableArray(this.list.map(function (show) {
          return _this.initPrice(show);
        }));
        this.morePostUrlList = [];
      }
    },
    // 跳转日历页
    gotoCalendarPage: function gotoCalendarPage() {
      window.lxTagReport('c_movie_aq5xt2v5', 'b_movie_bnzf3zsc_mc', {
        tab_id: 0,
        abtest: 1
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_bnzf3zsc_mc',
        cid: 'c_movie_aq5xt2v5',
        custom: {
          tab_id: 0,
          abtest: 1
        }
      });
      Drip.redirect('/myshow/#/new-calendar?tab=2');
    },
    handleClick: function handleClick(project) {
      var _ref = project || {},
        performanceId = _ref.performanceId,
        dataSeed = _ref.dataSeed,
        isNewMode = _ref.isNewMode;
      if (!performanceId) return;
      if (dataSeed) {
        window.seedAction(Object.assign({}, dataSeed, {
          needTag: true
        }));
      }
      var isNewPage = isNewMode === 0 ? false : true;
      var jumpDetailUrl = "/detail/".concat(performanceId, "?isNewPage=").concat(isNewPage);
      this.go(parseDetailUrl(jumpDetailUrl), {
        _blank: true
      });
    },
    switchActiveTab: function switchActiveTab(tab) {
      this.activeTab = tab;
      window.lxTagReport('c_movie_aq5xt2v5', 'b_movie_bnzf3zsc_mc', {
        tab_id: tab,
        abtest: 1
      });
      window.seedAction({
        evt: 'click',
        bid: 'b_movie_bnzf3zsc_mc',
        cid: 'c_movie_aq5xt2v5',
        custom: {
          tab_id: tab,
          abtest: 1
        }
      });
    },
    initPrice: function initPrice(show) {
      if (show.priceRange && show.priceRange !== '价格待定') {
        var priceArr = show.priceRange.split('-');
        if (priceArr.length > 1) {
          show.showPriceSuffix = true;
        }
      }
      return show;
    }
  }
};